import React from 'react';
import TerminalInReact from 'terminal-in-react';

/**
 * Thin wrapper around the `terminal-in-react` library, exposed as a shared
 * component so consuming apps don't need it as a direct dependency.
 *
 * @param {Object} props - Forwarded as-is to terminal-in-react's Terminal component.
 */
const Terminal = (props) => <TerminalInReact {...props} />;

export default Terminal;
